import { apiGet } from '../../api'

export const get_facilitator_programs = id => {
  return apiGet({
    endpoint: `programs/get_facilitator_programs?id=${id}`
  })
}
